export const SIGN_OUT_USER = "logoutUser"

export const NAVIGATE_TO_SETTINGS_PAGE = "navigateToSettingsPage"
export const NAVIGATE_TO_CREATE_ITEM_PAGE = "navigateToCreateItemPage"
export const NAVIGATE_TO_CREATE_LIST_PAGE = "navigateToCreateListPage"
export const NAVIGATE_TO_OTHER_USER_PROFILE_PAGE = "navigateToOtherUserProfilePage"
export const NAVIGATE_TO_LOGIN_PAGE = "navigateToLoginPage"
export const NAVIGATE_TO_FEED_PAGE = "navigateToFeedPage"
export const NAVIGATE_TO_SPECIFIC_PATH = "navigateToSpecificPath"
export const NAVIGATE_TO_ITEM_PAGE = "navigateToItemPage"
export const NAVIGATE_TO_PROFILE_PAGE = "navigateToProfilePage"
export const NAVIGATE_TO_PREMIUM_PLANS_PAGE = "navigateToPremiumPlansPage"

export const CLOSE_FULL_SCREEN_IMAGE_MODAL = "closeFullScreenModal"
export const DISCARD_IMAGE_CROP = "discardImageCrop"
export const SAVE_CROPPED_IMAGE = "saveCroppedImage"
export const PROFILE_IMAGE_CLICKED = "profileImageClicked"
export const SET_ORIGINAL_IMAGE = "setOriginalImage"

export const SWITCH_LIST_ITEM_VIEW_MODE = "switchListItemViewMode"
export const CLOSE_CREATE_NEW_LIST_OVERLAY = "closeCreateNewListOverlay"
export const OPEN_ITEM_ACTIONS_BOTTOM_SHEET = "openItemActionsBottomSheet"
export const HANDLE_TRANSFER_ITEM_TO_OTHER_LISTS = "handleTransferItemToOtherLists"
export const HANDLE_COPY_ITEM_LINK = "handleCopyItemLink"
export const HANDLE_EDIT_ITEM = "handleEditItem"
export const HANDLE_DELETE_ITEM = "handleDeleteItem"
export const OPEN_LIST_ACTIONS_BOTTOM_SHEET = "openListActionsBottomSheet"
export const HANDLE_ADD_ITEM_TO_LIST = "handleAddItemToList"
export const HANDLE_COPY_LIST_LINK = "handleCopyListLink"
export const HANDLE_EDIT_LIST = "handleEditList"
export const HANDLE_DELETE_LIST = "handleDeleteList"
export const ITEM_COMMENT_BUTTON_CLICKED = "itemCommentButtonClicked"
export const ITEM_LIKE_COUNT_CLICKED = "itemLikeCountClicked"
export const LIST_MORE_BUTTON_CLICKED = "listMoreButtonClicked"

export const CUSTOM_BACK_BUTTON_CLICKED = "customBackButtonClick"
export const FILTER_NOTIFICATIONS = "filterNotifications"

export const OPEN_SEND_OTP_BOTTOM_SHEET = "openSendOTPModal"
export const SHOW_NO_EMAIL_FOUND_MODAL = "showNoEmailFoundModal"
export const AVATAR_UPDATED = "avatarUpdated"
export const PWA_UPDATE_AVAILABLE = "pwaUpdateAvailable"
export const SHOW_SHARE_PROFILE_MODAL = "showShareProfileModal"
